import { NumberWithUnitValue, WhiteBox } from "@foodpilot/foods";
import { Box, useTheme } from "@mui/material";
import { LeverIndicatorCardContent } from "./LeverIndicatorCardContent";
import { LeverIndicatorDetailsButton } from "./LeverIndicatorDetailsButton";
import { LeverIndicatorGoal } from "./LeverIndicatorGoal";
import { LeverIndicatorGoals } from "./LeverIndicatorGoals";

type LeverIndicatorCardProps = {
    title: string;
    indicatorLabel: string;
    currentValue: NumberWithUnitValue;
    unit: string;
    currentValueColor?: string;
    goals: LeverIndicatorGoal[];
    canOpenDetails: boolean;
    openDetailsLabel: string;
    onOpenDetails?: () => void;
};

export const LeverIndicatorCard = (props: LeverIndicatorCardProps) => {
    const {
        title,
        indicatorLabel,
        currentValue,
        unit,
        currentValueColor,
        goals,
        canOpenDetails,
        openDetailsLabel,
        onOpenDetails,
    } = props;
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: "grid",
                gridRow: "1 / -1",
                gridTemplateRows: "subgrid",
                height: "100%",
                position: "relative",
                ...(canOpenDetails ? { "& h3": { paddingRight: theme.spacing(5) } } : {}),
            }}
        >
            <WhiteBox
                borderRadius="12px"
                boxShadow="none"
                bgcolor={theme.palette.background.paper}
                sx={{
                    display: "grid",
                    gridRow: "1 / -1",
                    gridTemplateRows: "subgrid",
                    height: "100%",
                    overflow: "hidden",
                }}
            >
                <LeverIndicatorCardContent
                    title={title}
                    indicatorLabel={indicatorLabel}
                    currentValue={currentValue}
                    unit={unit}
                    currentValueColor={currentValueColor}
                />
                <LeverIndicatorGoals goals={goals} />
            </WhiteBox>
            {canOpenDetails && <LeverIndicatorDetailsButton label={openDetailsLabel} onClick={onOpenDetails} />}
        </Box>
    );
};
